export const paths = {
  NEW: 'new',
  EDIT: 'edit',
  DELETE: 'delete',
}

export const emailAddressLinks = {
  newEmailAddressLink: () => `/${paths.NEW}`,
  editEmailAddressLink: (params: { emailId: string }) => `/${paths.EDIT}/${params.emailId}`,
  deleteEmailAddressLink: (params: { emailId: string }) => `/${paths.DELETE}/${params.emailId}`,
}

export type EmailAddressLinks = typeof emailAddressLinks
